module.exports = __webpack_public_path__ + "static/VS_Icons_color-04-8a900e66181e5f78cce690136e59302b.png";